import { ExpandLess, ExpandMore } from "@mui/icons-material";
import AddHomeIcon from "@mui/icons-material/AddHome";
import BarChartIcon from "@mui/icons-material/BarChart";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import DownloadIcon from "@mui/icons-material/Download";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import LockIcon from "@mui/icons-material/Lock";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import MenuIcon from "@mui/icons-material/Menu";
import PersonIcon from "@mui/icons-material/Person";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import WebhookIcon from "@mui/icons-material/Webhook";
import { Alert, Breadcrumbs, Collapse, Link, Snackbar } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { jwtDecode } from "jwt-decode";
import PropTypes from "prop-types";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import logoPortnet from "../../assets/images/portnetLogo.png";
import {
  clearTiSearchForm,
  resetState,
  setConsultingMode,
  setDrawerState,
  setIsAuthenticated,
  setIsTiDecisionMode,
} from "../../modules/TI/state/TiActions";
import { crcInstance } from "../Axios";
import {
  CHANGEMENT_MDP_PAGE,
  CONSULTATION_TITRES_PAGE,
  GESTION_CAUTION_PAGE,
  GESTION_TITRES_PAGE,
  ROOT_PAGE,
  WEB_SERVICE_PAGE,
} from "../constants/routerConstants";
import { getBankLogo, getRoles, hasAnyRole } from "../utils/FunctionsUtils";
import PopupDialogCustomized from "./PopupDialogCustomized";
import { PuiHelpWidget, PuiHelpWidgetProvider } from "@portnet/ui";
import config from "../../common/Config";

const drawerWidth = 240;

const userMenuStyles = {
  position: "absolute",
  right: 0,
  zIndex: 1,
  backgroundColor: "background.paper",
  color: "black",
  boxShadow: 3,
  borderRadius: "4px",
  overflow: "hidden",
  border: "1px solid",
  borderColor: "divider",
  padding: "4px 0",
};

const menuListStyles = {
  "&:hover": { backgroundColor: "action.hover" },
};

function DrawerMIC(props) {
  const roles = getRoles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { windowe } = props;
  const [drawerOpen, setDrawerOpen] = React.useState(true);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [menuIndex, setMenuIndex] = React.useState(0);
  const [sousMenuIndex, setSousMenuIndex] = React.useState(0);
  const [menus, setMenus] = React.useState([]);
  const [openUserMenu, setOpenUserMenu] = React.useState(false);
  const [openLogoutDialog, setOpenLogoutDialog] = React.useState(false);
  const [breadcrumb, setBreadcrumb] = React.useState("");
  const [currentPath, setCurrentPath] = React.useState("");
  const [openResetDialog, setOpenResetDialog] = React.useState(false);

  const [alertMessage, setAlertMessage] = React.useState(null);
  const [alertOpen, setAlertOpen] = React.useState(false);
  const [severity, setSeverity] = React.useState(null);

  const initialSearchTitreObject = useSelector(
    (state) => state?.tiReducer?.initialSearchTitreObject,
  );
  const listMenus = [
    {
      name: "Tableau de bord",
      icon: <AddHomeIcon />,
      color: "#25384a",
      headerTitle: "Tableau de bord",
      headerIcon: <AddHomeIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>Tableau de bord</Box>,
      collapse: false,
      to: "/home",
      sousMenus: [],
      hide: true,
    },
    {
      name: "Importation",
      icon: <DownloadIcon />,
      color: "#25384a",
      headerTitle: "Gestion des demandes",
      collapse: false,
      headerIcon: <ManageSearchIcon />,
      sousMenus: [
        {
          name: "Gestion Titre et documents",
          icon: <LayersOutlinedIcon />,
          color: "#25384a",
          to: GESTION_TITRES_PAGE,
          headerIcon: <ManageSearchIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole([
            "ROLE_VUPORTUARIA_BANCO",
            "ROLE_VUPORTUARIA_ADMIN",
          ]),
        },
        {
          name: "Consultation Titre et documents",
          icon: <LayersOutlinedIcon />,
          color: "#25384a",
          to: CONSULTATION_TITRES_PAGE,
          headerIcon: <ManageSearchIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole([
            "ROLE_VUPORTUARIA_BANCO",
            "ROLE_VUPORTUARIA_ADMIN",
          ]),
        },
      ],
      hide: !hasAnyRole(["ROLE_VUPORTUARIA_BANCO", "ROLE_VUPORTUARIA_ADMIN"]),
    },
    {
      name: "Caution bancaire",
      icon: <CreditScoreIcon />,
      color: "#25384a",
      headerTitle: "Gestion des demandes",
      collapse: false,
      headerIcon: <CreditScoreIcon />,
      sousMenus: [],
      to: GESTION_CAUTION_PAGE,
      hide: !hasAnyRole(["ROLE_VUPORTUARIA_BANCO", "ROLE_VUPORTUARIA_ADMIN"]),
    },
    // {
    //   name: "Web service",
    //   icon: <WebhookIcon />,
    //   color: "#25384a",
    //   headerTitle: "Web service",
    //   collapse: false,
    //   headerIcon: <WebhookIcon />,
    //   sousMenus: [
    //     {
    //       name: "Émission/Réception de messages",
    //       icon: <WebhookIcon />,
    //       color: "#25384a",
    //       to: WEB_SERVICE_PAGE,
    //       headerIcon: <WebhookIcon sx={{ height: 50, width: "auto" }} />,
    //       hide: !hasAnyRole(["ROLE_VUPORTUARIA_BANCO"]),
    //     },
    //   ],
    //   hide: !hasAnyRole(["ROLE_VUPORTUARIA_BANCO"]),
    // },
    {
      name: "Portnet's KPI",
      icon: <BarChartIcon />,
      color: "#25384a",
      headerTitle: "Portnet's KPI",
      headerIcon: <BarChartIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>Portnet's KPI</Box>,
      collapse: false,
      externalUrl: "https://pkpi-v1.portnet.ma/",
      sousMenus: [],
      hide: !hasAnyRole(["ROLE_VUPORTUARIA_BANCO"]),
    },
    {
      name: "Changement de mot de passe",
      color: "#25384a",
      headerTitle: "Changement de mot de passe",
      headerIcon: <LockIcon sx={{ height: 50, width: "auto" }} />,
      to: "/changementmdp",
      sousMenus: [],
      hidden: true,
      hideBreadcrumb: true,
    },
  ];

  const appBarStyles = {
    width: {
      xs: "100%",
      sm: drawerOpen ? `calc(100% - ${drawerWidth}px)` : "100%",
    },
    ml: { sm: drawerOpen ? `${drawerWidth}px` : 0 },
    transition: "margin 0.22s ease, width 0.22s ease",
  };

  const mainContentStyles = {
    flexGrow: 1,
    p: 3,
    marginTop: 9,
    width: "100px",
  };

  const token = localStorage.getItem("token");
  let username = "";
  let bankLogoPath = null;
  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      username =
        (decodedToken.firstname || "") + " " + (decodedToken.lastname || "");
      bankLogoPath = getBankLogo(decodedToken.codeBanque);
    } catch (error) {
      console.error("Error decoding token", error);
    }
  }

  React.useEffect(() => {
    setMenus(listMenus);
  }, [localStorage.getItem("token")]);

  React.useEffect(() => {
    const currentPath = location.pathname;
    let foundMenuIndex = -1;
    let foundSousMenuIndex = -1;

    menus?.forEach((menu, index) => {
      if (menu?.to?.toLowerCase() === currentPath?.toLowerCase()) {
        foundMenuIndex = index;
        foundSousMenuIndex = -1;
      }
      menu?.sousMenus?.forEach((sousMenu, sousIndex) => {
        if (sousMenu?.to?.toLowerCase() === currentPath?.toLowerCase()) {
          foundMenuIndex = index;
          foundSousMenuIndex = sousIndex;
        }
      });
    });

    if (foundMenuIndex !== -1) {
      setMenuIndex(foundMenuIndex);
      setSousMenuIndex(foundSousMenuIndex);
      setBreadcrumb(
        <Breadcrumbs
          aria-label="breadcrumb"
          separator=">"
          sx={{
            "& .MuiBreadcrumbs-separator": {
              color: "#25384a",
            },
          }}
        >
          <Link underline="none" color="inherit" sx={{ color: "#25384a" }}>
            {menus[foundMenuIndex]?.name}
          </Link>
          {menus[foundMenuIndex]?.sousMenus[foundSousMenuIndex]?.name && (
            <Link underline="none" color="inherit" sx={{ color: "#25384a" }}>
              {menus[foundMenuIndex]?.sousMenus[foundSousMenuIndex]?.name}
            </Link>
          )}
        </Breadcrumbs>,
      );
    }
  }, [location, menus]);

  const handlePasswordChange = () => {
    setMenuIndex(
      menus.findIndex(
        (menu, index) => menu?.to?.toLowerCase() === "/changementmdp",
      ),
    );
    setOpenUserMenu(false);
    navigate(CHANGEMENT_MDP_PAGE);
  };
  const handleResetClick = () => {
    setOpenResetDialog(true);
  };

  const handleLogoutClick = () => {
    setOpenLogoutDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenLogoutDialog(false);
    setOpenResetDialog(false);
  };

  const handleConfirmReset = async () => {
    try {
      let token = localStorage.getItem("token");

      if (!token) {
        await new Promise((resolve) => setTimeout(resolve, 100));
        token = localStorage.getItem("token");
      }
      const response = await crcInstance.delete("/api/user/resetMFA", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setAlertMessage(response?.data);
      handleCloseDialog();
      setAlertOpen(true);
      setSeverity("success");
    } catch (error) {
      setAlertMessage(error?.response?.data);
      setAlertOpen(true);
      setSeverity("error");
    }
  };

  const handleSnackClose = (reason) => {
    if (reason === "clickaway") {
      return;
    }

    setTimeout(() => { }, 2500);

    setAlertOpen(false);
  };

  const handleConfirmLogout = () => {
    localStorage.removeItem("token");
    dispatch(setIsAuthenticated(false));
    dispatch(resetState());
    setOpenLogoutDialog(false);
    navigate(ROOT_PAGE);
  };

  const handleUserIconClick = () => {
    setOpenUserMenu((prev) => !prev);
  };

  const handleClickAway = () => {
    setOpenUserMenu(false);
  };

  const handleMobileDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
    const payload = {
      open: !drawerOpen,
      width: drawerWidth,
    };
    dispatch(setDrawerState(payload));
  };

  const drawSousMenus = (sousMenus, indexMenu) => {
    return (
      <div style={{ marginLeft: "-10px" }}>
        {sousMenus.map(
          (menu, indexSousMenu) =>
            !menu.hide && (
              <ListItem
                key={menu.name}
                disablePadding
                onClick={() => onClickSousMenu(indexMenu, indexSousMenu)}
                sx={{
                  color: "#25384a",
                  backgroundColor:
                    indexMenu === menuIndex && indexSousMenu === sousMenuIndex
                      ? "white"
                      : "transparent",
                  "&:hover": {
                    backgroundColor: "white",
                    ".MuiListItemText-primary": { color: "primary.main" },
                    ".MuiListItemIcon-root": { color: "primary.main" },
                  },
                  borderLeft:
                    indexMenu === menuIndex && indexSousMenu === sousMenuIndex
                      ? "4px solid #25384a"
                      : "4px solid transparent",
                  borderTop:
                    indexMenu === menuIndex && indexSousMenu === sousMenuIndex
                      ? "1.5px solid #25384a"
                      : "1.5px solid transparent",
                  borderBottom:
                    indexMenu === menuIndex && indexSousMenu === sousMenuIndex
                      ? "1.5px solid #25384a"
                      : "1.5px solid transparent",
                }}
              >
                <ListItemButton
                  sx={{ justifyContent: "space-between", paddingY: 0 }}
                >
                  <div>
                    <ListItemText
                      primary={menu.name}
                      sx={{
                        ".MuiListItemText-primary": {
                          color:
                            indexMenu === menuIndex &&
                              indexSousMenu === sousMenuIndex
                              ? "primary.main"
                              : "inherit",
                          ".MuiListItemIcon-root": { color: "primary.main" },
                        },
                      }}
                    />
                  </div>
                  <div>
                    {indexMenu === menuIndex &&
                      indexSousMenu === sousMenuIndex && (
                        <ListItemIcon
                          sx={{
                            minWidth: "auto",
                            mr: -2,
                            color:
                              indexMenu === menuIndex &&
                                indexSousMenu === sousMenuIndex
                                ? "#25384a"
                                : "inherit",
                            ".MuiListItemIcon-root": { color: "primary.main" },
                          }}
                        >
                          <PlayArrowIcon />
                        </ListItemIcon>
                      )}
                  </div>
                </ListItemButton>
              </ListItem>
            ),
        )}
      </div>
    );
  };

  const isLeafNode = (index) => menus[index].sousMenus.length === 0;

  const onClickMenu = (index) => {
    const selectedMenu = menus[index];
    if (selectedMenu.externalUrl) {
      let url =
        selectedMenu.externalUrl + `?token=${localStorage.getItem("token")}`;
      window.open(url, "_blank");
      return;
    }

    let menuList = [...menus];

    menuList.forEach((menu, idx) => {
      if (idx !== index) {
        menu.collapse = false;
      }
    });

    menuList[index].collapse = !menuList[index].collapse;
    setMenus(menuList);

    if (isLeafNode(index)) {
      setMenuIndex(index);
      navigate(menuList[index].to);
    }
  };

  const onClickSousMenu = (indexMenu, indexSousMenu) => {
    setSousMenuIndex(indexSousMenu);
    setMenuIndex(indexMenu);
    const sousMenu = menus[indexMenu].sousMenus[indexSousMenu];
    switch (sousMenu.to) {
      case GESTION_TITRES_PAGE:
        if (currentPath !== GESTION_TITRES_PAGE) {
          setCurrentPath(GESTION_TITRES_PAGE);
          dispatch(clearTiSearchForm());
          dispatch(setIsTiDecisionMode(true));
          dispatch(setConsultingMode(false));
        }
        break;
      case "/consultationTitres":
        if (currentPath !== "/consultationTitres") {
          setCurrentPath("/consultationTitres");
          dispatch(clearTiSearchForm());
          dispatch(setIsTiDecisionMode(false));
          dispatch(setConsultingMode(true));
        }
        break;
      default:
        break;
    }
    navigate(sousMenu.to);
  };

  const drawer = (
    <div style={{ backgroundColor: "#f2f2f2", height: "100%" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: 2,
        }}
      >
        <Box sx={{ marginTop: "10px" }}>
          <img alt="" src={bankLogoPath} style={{ height: 80 }} />
        </Box>
        <Box sx={{ textAlign: "center" }}>
          <Typography
            sx={{
              fontWeight: "bold",
              color: "primary.main",
              marginTop: 1,
            }}
          >
            {username}
          </Typography>
        </Box>
      </Box>
      <List
        sx={{
          marginTop: 0.5,
          position: "fixed",
          width: 240,
        }}
      >
        {menus.map(
          (menu, index) =>
            menu.hidden !== true &&
            !menu.hide && (
              <React.Fragment key={menu.name}>
                <ListItem
                  disablePadding
                  onClick={() => onClickMenu(index)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    backgroundColor:
                      isLeafNode(index) && index === menuIndex
                        ? "white"
                        : "transparent",
                    ".MuiListItemText-primary": {
                      color:
                        isLeafNode(index) && index === menuIndex
                          ? "primary.main"
                          : "#25384a",
                      fontWeight: index === menuIndex ? 700 : 400,
                    },
                    zIndex:
                      isLeafNode(index) && index === menuIndex ? 100 : "auto",
                    borderLeft:
                      isLeafNode(index) && index === menuIndex
                        ? "4px solid #25384a"
                        : "4px solid transparent",
                    borderTop:
                      isLeafNode(index) && index === menuIndex
                        ? "1.5px solid #25384a"
                        : "1.5px solid transparent",
                    borderBottom:
                      isLeafNode(index) && index === menuIndex
                        ? "1.5px solid #25384a"
                        : "1.5px solid transparent",
                    "&:hover": {
                      backgroundColor: "white",
                      ".MuiListItemText-primary": { color: "primary.main" },
                      ".MuiListItemIcon-root": { color: "primary.main" },
                    },
                  }}
                >
                  <ListItemButton
                    sx={{
                      paddingY: 0,
                      ml: -1.5,
                      "&:hover .expandItem": {
                        color: "primary.main",
                      },
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        color:
                          index === menuIndex && menu.sousMenus.length === 0
                            ? "primary.main"
                            : "#25384a",
                        "&:hover": { color: "primary.main" },
                      }}
                    >
                      {React.cloneElement(menu.icon, {
                        color:
                          index === menuIndex &&
                            sousMenuIndex === 0 &&
                            menu.sousMenus.length === 0
                            ? "primary.main"
                            : undefined,
                      })}
                    </ListItemIcon>
                    <ListItemText
                      primary={menu.name}
                      primaryTypographyProps={{
                        fontSize: "16px",
                      }}
                      sx={{
                        color: "white",
                        ".MuiTypography-root": {
                          fontWeight: 400,
                        },
                        "& .MuiListItemText-primary": {
                          marginLeft: "-16px",
                          fontWeight:
                            index === menuIndex ||
                              (menu.sousMenus.length > 0 && menuIndex === index)
                              ? "700"
                              : "400",
                        },
                      }}
                    />
                    {menu.sousMenus.length === 0 && index === menuIndex && (
                      <ListItemIcon
                        sx={{
                          minWidth: "auto",
                          mr: -2,
                          color: "#25384a",
                        }}
                      >
                        <PlayArrowIcon />
                      </ListItemIcon>
                    )}
                    {menu.sousMenus.length > 0 && (
                      <Box
                        sx={{
                          ml: "auto",
                          display: "flex",
                        }}
                      >
                        {menu.collapse ? (
                          <ExpandLess
                            className="expandItem"
                            sx={{
                              color: "#25384a",
                              "&:hover": {
                                color: "primary.main",
                              },
                            }}
                          />
                        ) : (
                          <ExpandMore
                            className="expandItem"
                            sx={{
                              color: "#25384a",
                              "&:hover": {
                                color: "primary.main",
                              },
                            }}
                          />
                        )}
                      </Box>
                    )}
                  </ListItemButton>
                </ListItem>
                {menu.sousMenus?.length !== 0 && (
                  <Collapse
                    in={menu.collapse}
                    timeout="auto"
                    unmountOnExit
                    sx={{ marginLeft: 4 }}
                  >
                    <List component="div" disablePadding>
                      {drawSousMenus(menu.sousMenus, index)}
                    </List>
                  </Collapse>
                )}
              </React.Fragment>
            ),
        )}
      </List>

      <Box
        position={"fixed"}
        sx={{
          bottom: 30,
          width: 240,
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <img
          alt=""
          src={logoPortnet}
          style={{
            height: 40,
            marginBottom: -25,
          }}
        />
      </Box>
    </div>
  );

  const container =
    windowe !== undefined ? () => windowe().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{ ...appBarStyles, backgroundColor: "#f2f2f2" }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleMobileDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          {!drawerOpen && (
            <IconButton
              edge="start"
              onClick={handleDrawerToggle}
              sx={{
                mr: 2,
                display: { xs: "none", sm: "inline-flex" },
                color: "primary.main",
              }}
            >
              <MenuIcon />
            </IconButton>
          )}

          <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {menus[menuIndex]?.sousMenus?.length !== 0
                ? menus[menuIndex]?.sousMenus[sousMenuIndex]?.headerIcon &&
                React.cloneElement(
                  menus[menuIndex]?.sousMenus[sousMenuIndex]?.headerIcon,
                  { sx: { color: "primary.main", fontSize: 40 } },
                )
                : menus[menuIndex]?.headerIcon &&
                React.cloneElement(menus[menuIndex]?.headerIcon, {
                  sx: { color: "primary.main", fontSize: 40 },
                })}
              <Typography
                variant="h6"
                noWrap
                component="div"
                sx={{
                  marginLeft: 1,
                  fontWeight: "bold",
                  color: "primary.main",
                }}
              >
                {menus[menuIndex]?.headerTitle}
              </Typography>
            </Box>
            {menus[menuIndex]?.hideBreadcrumb !== true && (
              <Typography variant="caption" sx={{ color: "primary.main" }}>
                {breadcrumb}
              </Typography>
            )}
          </Box>

          <ClickAwayListener onClickAway={handleClickAway}>
            <Box sx={{ position: "relative" }}>
              <IconButton
                onClick={handleUserIconClick}
                sx={{ color: "primary.main" }}
              >
                <PersonIcon />
              </IconButton>
              {openUserMenu && (
                <Box sx={userMenuStyles}>
                  <MenuList sx={{ padding: "4px 0", zIndex: 9999 }}>
                    <MenuItem
                      onClick={handlePasswordChange}
                      sx={menuListStyles}
                    >
                      Modifier le mot de passe
                    </MenuItem>
                    <MenuItem onClick={handleResetClick} sx={menuListStyles}>
                      Réinitialiser MFA
                    </MenuItem>

                    <MenuItem onClick={handleLogoutClick} sx={menuListStyles}>
                      Se déconnecter
                    </MenuItem>
                  </MenuList>
                </Box>
              )}
            </Box>
          </ClickAwayListener>
        </Toolbar>
      </AppBar>

      <Box
        component="nav"
        sx={{
          width: {
            sm: mobileOpen ? drawerWidth : drawerOpen ? drawerWidth : 0,
          },
          transition: "margin 0.22s ease, width 0.22s ease",
          flexShrink: { sm: 0 },
        }}
      >
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleMobileDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              borderColor: "#25384a",
              borderWidth: "1.5px",
            },
          }}
        >
          <div style={{ overflowY: "auto", height: "100%" }}>{drawer}</div>
        </Drawer>
        <Drawer
          variant="persistent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              borderColor: "#25384a",
              borderWidth: "1.5px",
              color: "text.white",
            },
          }}
          open={drawerOpen}
        >
          {drawerOpen && (
            <IconButton
              aria-label="close"
              onClick={handleDrawerToggle}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "primary.main",
              }}
            >
              <KeyboardBackspaceIcon />
            </IconButton>
          )}
          {drawer}
        </Drawer>
      </Box>
      <Box component="main" sx={mainContentStyles}>
        {props.content}
      </Box>

      {config.showReclamation && <PuiHelpWidgetProvider
        baseURL={config.baseURL}
        tijariaUrl={config.tijariaUrl}
        apiAuthUrl={config.authUrl}
        guideBaseUrl={config.guideBaseUrl}
        token={localStorage.getItem("token")}
        showReclamation={config.showReclamation}
        showGuides={false}
        portailId={4}
        showTijaria={config.showTijaria}
      >
        <PuiHelpWidget />
      </PuiHelpWidgetProvider>}

      <PopupDialogCustomized
        open={openLogoutDialog}
        onClose={handleCloseDialog}
        title="Déconnexion"
        description={"Voulez-vous vraiment vous déconnecter?"}
        primaryButtonLabel="Oui"
        onPrimaryButtonClick={handleConfirmLogout}
        secondaryButtonLabel="Annuler"
        onSecondaryButtonClick={handleCloseDialog}
      />

      <PopupDialogCustomized
        open={openResetDialog}
        onClose={handleCloseDialog}
        title="Réinitialisation MFA"
        description={"Voulez-vous vraiment réinitialiser votre MFA?"}
        primaryButtonLabel="Oui"
        onPrimaryButtonClick={handleConfirmReset}
        secondaryButtonLabel="Annuler"
        onSecondaryButtonClick={handleCloseDialog}
      />

      <Box>
        <Snackbar
          open={alertOpen}
          autoHideDuration={2000}
          onClose={handleSnackClose}
        >
          <Alert
            onClose={handleSnackClose}
            severity={severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {alertMessage}
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
}

DrawerMIC.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * Remove this when copying and pasting into your project.
   */
  windowee: PropTypes.func,
};

export default DrawerMIC;
